export default key => {
  let value = defaults[key];
  if (typeof window !== "undefined") {
    value =
      window.config && window.config[key] !== undefined
        ? window.config[key]
        : defaults[key];
  }
  return value;
};

const defaults = {
  CONSOLE_URL: "https://console.humanitix.com",
  TICKETING_URL: "https://events.humanitix.com",
  HELP_DOCS_URL: "https://humanitix.helpdocs.io",
  ALGOLIA_APP_ID: "VQHD8CBFYJ",
  ALGOLIA_SEARCH_API_KEY: "98752ba18cb832c23167defbfe33d878",
  ALGOLIA_INDEX: "events_aus_staging",
  ALGOLIA_INDEX_WIDGETS: "events_staging_widgets",
  ZIPMONEY_ENV: "sandbox",
  ZIPMONET_MERCHANT_UNIQUE_ID: "f18b506d-ddf9-4ed0-bdb7-febdf48e6d6d",
  ZIP_WIDGET_SCRIPT:
    "https://static.zipmoney.com.au/lib/js/zm-widget-js/dist/zip-widget.min.js",
  ZIP_JQUERY_SCRIPT: "https://code.jquery.com/jquery-latest.min.js",
  API_URL: "http://localhost:3005/api",
  GOOGLE_API_KEY: "AIzaSyBrLKaAEokK10u3KCRKI0WJyXUN6iAT6AI",
  SEARCH_PREFERENCE_LAT: -34,
  SEARCH_PREFERENCE_LNG: 151,
  HUMANITIX_CONTACT_NUMBER: "02 9986 2635",
  ENV: "Local",
  SENTRY_ERROR_ACCESS_APP:
    "https://5e6208fdbe154ee6b9bbd6ec71822083@sentry.io/1869937",
  NODE_ENV: "local",
  AU_CHARITY: "5b21f44fed1bb51b4e94f9e6",
  INTERNATIONAL_CHARITY: "5b21f44fed1bb51b4e94f9fe,5b15e2dd6772e9f238e3b49a",
  NZ_CHARITY: "5e4e17fa862f9844e0300d12"
};
